import whenDomReady from 'when-dom-ready';
import Cookies from 'js-cookie';
const COOKIE_NAME = 'xperience.cookiebannerlightbox';
const COOKIE_DOMAIN = window.location.hostname;
const wrap = (toWrap, wrapper) => {
    wrapper = wrapper || document.createElement('div');
    const parent = toWrap.parentNode;
    if (!parent)
        return;
    parent.appendChild(wrapper);
    wrapper.appendChild(toWrap);
    return;
};
const unwrap = (wrapper) => {
    const docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        const child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }
    const parent = wrapper.parentNode;
    if (!parent)
        return;
    parent.replaceChild(docFrag, wrapper);
    return;
};
const flagClosed = () => {
    Cookies.set(COOKIE_NAME, 'closed', { expires: 365, domain: '.' + COOKIE_DOMAIN });
};
function initialise() {
    const banner = document.querySelector('.js-xpcookiebanner');
    const hasBeenClosed = Cookies.get(COOKIE_NAME) === 'closed';
    if (!banner || hasBeenClosed || window.innerWidth < 768) {
        return;
    }
    const lightboxActive = document.querySelector('.js-header--xpcookiebanner-is-active');
    if (!lightboxActive) {
        return;
    }
    const contentHolder = document.createElement('div');
    contentHolder.className = 'lightbox__content-holder';
    wrap(banner, contentHolder);
    const lightbox = document.createElement('div');
    lightbox.className = 'lightbox__content lightbox__content--xpcookiebanner';
    wrap(contentHolder, lightbox);
    const overlay = document.createElement('div');
    overlay.className = 'lightbox__overlay';
    lightbox.appendChild(overlay);
    const close = document.createElement('div');
    close.className = 'lightbox__close';
    banner.appendChild(close);
    const lightboxClose = document.querySelector('.lightbox__close');
    if (lightboxClose) {
        lightboxClose.addEventListener('click', () => {
            lightbox.removeChild(overlay);
            banner.removeChild(close);
            unwrap(lightbox);
            unwrap(contentHolder);
            flagClosed();
        });
    }
    const closeCookieBar = document.querySelector('.js-close-cookie');
    if (closeCookieBar) {
        closeCookieBar.addEventListener('click', () => {
            setTimeout(() => {
                const parent = lightbox.parentNode;
                if (!parent)
                    return;
                parent.removeChild(lightbox);
                flagClosed();
            }, 0);
        });
    }
}
whenDomReady().then(initialise);
